import { render, staticRenderFns } from "./playvedio.vue?vue&type=template&id=9628ea7c&scoped=true&"
import script from "./playvedio.vue?vue&type=script&lang=js&"
export * from "./playvedio.vue?vue&type=script&lang=js&"
import style0 from "./playvedio.vue?vue&type=style&index=0&lang=css&"
import style1 from "./playvedio.vue?vue&type=style&index=1&id=9628ea7c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9628ea7c",
  null
  
)

export default component.exports